<template>
    <div>
        <el-dialog
            title="图片预览"
            :close-on-click-modal="false"
            :append-to-body="true"
            :visible.sync="visibleImg">
            <div class="modal-content">
                <el-row v-if="isShowImgUpload" style="padding-left:100px;padding-right:100px;">
                    <el-col :span="4" style="color:white">1</el-col>
                    <el-col :span="16">
                        <div style="position:relative;background-color: #f0f3fa;">
                            <el-image
                                :src="localUrl"
                                :preview-src-list="[localUrl]"
                                style="width:100%;height:100%;"
                                fit="scale-down"
                            />
                        </div>
                    </el-col>
                    <el-col :span="4" style="color:white">1</el-col>
                </el-row>
            </div>
        </el-dialog>
        <el-dialog
            title="PDF预览"
            :close-on-click-modal="false"
            :append-to-body="true"
            :visible.sync="visiblePdf">
            <pdf
                class="pdf"
                :page="pageNum"
                :src="pdfSrc"
                @progress="loadedRatio = $event"
                @num-pages="pageTotalNum = $event"
            ></pdf>
            <div class="page-box">
                <el-button-group>
                    <el-button
                        type="primary"
                        icon="el-icon-arrow-left"
                        size="mini"
                        @click="prePage"
                    >上一页</el-button
                    >
                    <el-button type="primary" size="mini" @click="nextPage"
                    >下一页<i class="el-icon-arrow-right el-icon--right"></i
                    ></el-button>
                </el-button-group>
                <div style=" color: #409EFF;display: flex;justify-content: flex-end;">
                    {{ pageNum }} / {{ pageTotalNum }}
                </div>
            </div>
        </el-dialog>
        <el-dialog
            title="视频预览"
            :close-on-click-modal="false"
            :append-to-body="true"
            @close="cancel"
            :visible.sync="visibleVideo">
            <video-player
                class="video-player vjs-custom-skin"
                ref="videoPlayer"
                :playsinline="true"
                :options="playerOptions"
            >
            </video-player>
        </el-dialog>
        <!--<el-dialog
            v-if="previewShow"
            title="WORD预览"
            :visible.sync="previewShow"
            append-to-body
            width="90%"
        >
            &lt;!&ndash; word 显示&ndash;&gt;
            <div ref="word"></div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" plain @click="previewShow = false">关 闭</el-button>
            </span>
        </el-dialog>-->
        <three-d
            ref="threeBox"
            :innerVisible="innerVisible"
            :fileListNew="fileListNew"
            @closeDlog="closeDlog"
        ></three-d>
    </div>
</template>

<script>
import pdf from 'vue-pdf';
import threeD from "../../components/threeD/index"
export default {
    name: "videoDialog",
    components:{
        threeD,
        pdf
    },
    data(){
        return {
            previewShow:false,
            visibleVideo:false,
            playerOptions: {
                playbackRates: [0.5, 1.0, 1.5, 2.0],//倍速控制
                autoplay: true,//是否自动播放
                muted: false,//是否静音播放
                loop: false,//是否循环播放
                preload: "auto",
                language: "zh-CN", //语言，还要引入对应的文件
                aspectRatio: "16:9",//比例
                fluid: true,
                sources: [
                    {
                        type: "",
                        src: "", //url地址
                    },
                ],
                poster: "", //你的封面地址
                notSupportedMessage: "此视频暂无法播放，请稍后再试",
                controlBar: {
                    timeDivider: true,
                    durationDisplay: true,//剩余时间是否显示
                    remainingTimeDisplay: false,//剩余时间是否显示，有一个即可
                    fullscreenToggle: true,//全屏按钮
                },
            },
            visiblePdf:false,
            pdfSrc: "",
            numPages: undefined,
            pageNum: 1,
            pageTotalNum: 1, // 总页数
            // 3D预览
            fileListNew: [],
            innerVisible: false,
            // 图片预览
            isShowImgUpload:false,
            localUrl:"",
            visibleImg:false,
        }
    },
    methods: {
        init(detail,fileType,fileUrl){
            if(detail==="view") {
                this.playerOptions.sources[0].src = "";
                this.localUrl = "";
                // STL文件预览
                if (fileType === "STL") {
                    this.$refs.threeBox.threeAnimal({modelUrl: fileUrl}, 'model');
                    this.innerVisible = !this.innerVisible;
                } else if (fileType === "PNG" || fileType === "JPG"
                    || fileType === "BMP" || fileType === "JPEG") {
                    // 图片预览
                    this.showImg(fileUrl);
                } else if (fileType === "PDF" || fileType === "pdf") {
                    // pdf预览
                    this.pdfSrc = pdf.createLoadingTask(fileUrl);
                    this.pdfSrc.promise.then(pdf => {
                        this.numPages = pdf.numPages;
                    });
                    this.visiblePdf = true;
                } else if (fileType === "MP4" || fileType === "mp4" || fileType === "wmv") {
                    // video预览
                    this.playerOptions.sources[0].src = fileUrl;
                    this.visibleVideo = true;
                }/*else if(fileType==="DOC"||fileType==="DOCX"){
                // word预览
                this.previewShow = true;
                axios.get(fileUrl, {
                    responseType: "blob",
                })
                .then((res) => {
                    // 对后端返回二进制流做处理
                    const blob = new Blob([res]);
                    docx.renderAsync(blob, this.$refs.word);
                });
            }*/ else {
                    this.$message.error("暂不支持" + fileType + "格式的预览");
                }
            }else if(detail==="download"){
                const x = new window.XMLHttpRequest();
                x.open('GET', fileUrl, true);
                x.responseType = "blob";
                x.onload = () =>{
                    const url = window.URL.createObjectURL(x.response);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = fileType;
                    a.click();
                };
                x.send();
            }
        },
        cancel() {
            this.playerOptions.sources[0].src = "";
            //视频结束  通过$refs获取video标签ref属性pause关闭视频
            //this.$refs.videoPlayer.pause();
        },
        prePage () {
            let page = this.pageNum;
            page = page > 1 ? page - 1 : this.pageTotalNum;
            this.pageNum = page
        },
        // 下一页
        nextPage () {
            let page = this.pageNum;
            page = page < this.pageTotalNum ? page + 1 : 1;
            this.pageNum = page
        },
        closeDlog(index){
            this.innerVisible = index;
        },
        showImg (url) {
            this.visibleImg = true;
            this.localUrl = url;
            this.isShowImgUpload = true;//呈现本地预览组件
        },
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/examine/viewFileDialog.vue